var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 166,
    viewBox: "0 0 143 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_60035)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.466 33.0781V118.952H106.862V55.9358L77.5539 89.5095L41.4713 55.1727V116.239H32.8672V35.1979L76.9747 77.1714L115.466 33.0781Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.171875 0.000488281L134.396 135.663V27.3794H143V156.505L8.77597 20.8425V116.239H0.171875V0.000488281Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.828 156.428H0V127.6H125.62L142.828 156.428Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93848 130.492H9.32002L19.997 147.367V130.492H22.7167V151.323H19.5078L8.67249 134.463V151.323H5.93848V130.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5084 130.492H42.9196V133.045H30.3V139.369H41.9699V141.78H30.3V148.841H43.1354V151.323H27.5084V130.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2735 130.492V132.974H55.1507V151.323H52.244V132.974H45.1212V130.492H62.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8348 130.492H68.9358L75.0082 148.104L81.0374 130.492H85.0953V151.323H82.3757V139.029C82.3757 138.603 82.3853 137.899 82.4044 136.916C82.4236 135.933 82.4332 134.879 82.4332 133.754L76.404 151.323H73.5693L67.4969 133.754V134.392C67.4969 134.902 67.5065 135.682 67.5257 136.731C67.5544 137.771 67.5688 138.537 67.5688 139.029V151.323H64.8348V130.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7287 130.492H105.14V133.045H92.5203V139.369H104.19V141.78H92.5203V148.841H105.356V151.323H89.7287V130.492Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_60035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 165,
    fill: "white",
    transform: "translate(0 0.0771484)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.d29fe2751c4cfbc3cf455a7789c08dea.svg";
export { ForwardRef as ReactComponent };